import { useState } from "react";
import { useOnMount } from "../index";
import authenticatedPopsApi from "../../utils/portalApi";

export const useResource = (url, fallback, axios = authenticatedPopsApi) => {
  const [resource, setResource] = useState(fallback);
  const [isFetching, setIsFetching] = useState(true);
  const [requestFailed, setRequestFailed] = useState(false);

  useOnMount(() => {
    const getData = async () => {
      setIsFetching(true);

      try {
        const response = await axios.get(url);
        const { status, data } = response;
        const { value } = data;
        if (status === 200) {
          setResource(value);
        } else {
          setRequestFailed(true);
        }
      } catch (error) {
        setRequestFailed(true);
      }
    };

    getData().finally(() => setIsFetching(false));
  });

  return [resource, isFetching, requestFailed];
};